"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bookmark = void 0;
var Bookmark = /** @class */ (function () {
    function Bookmark(line, col, pos) {
        if (line === void 0) { line = 0; }
        if (col === void 0) { col = 0; }
        if (pos === void 0) { pos = 0; }
        this.line = line;
        this.col = col;
        this.pos = pos;
    }
    Bookmark.prototype.append = function (c) {
        this.pos++;
        this.col++;
        if (c === '\n') {
            this.line++;
            this.col = 0;
        }
        return c;
    };
    Bookmark.prototype.clone = function () {
        return new Bookmark(this.line, this.col, this.pos);
    };
    Bookmark.prototype.toString = function () {
        return "Bookmark(line=" + this.line + ", col=" + this.col + ", pos=" + this.pos + ")";
    };
    return Bookmark;
}());
exports.Bookmark = Bookmark;
//# sourceMappingURL=Bookmark.js.map